import { Component, OnInit } from '@angular/core';
import { AccountResource, Organization, OrganizationResource, PaymentDetails, SubscriptionInvoice, SubscriptionInvoiceResource, SubscriptionPlan, SubscriptionPlanResource } from '@apaq/orgkit-js';
import { container } from 'tsyringe';
import { DialogService } from '../../dialog/dialog.service';
import { SubscriptionPlanCalculator } from '../subscription-plan-calculator';
import { Data, Result, StripeComponent } from './stripe/stripe.component';

@Component({
  selector: 'app-subscription-view',
  templateUrl: './subscription-view.component.html',
  styleUrls: ['./subscription-view.component.scss']
})
export class SubscriptionViewComponent implements OnInit {
  
  visible: boolean = false;
  loading = false;
  organization?: Organization;
  invoices?: SubscriptionInvoice[];
  numberOfWorkers: number = 0;
  subscriptionPlan?: SubscriptionPlan;
  togglingSubscription = false;
  changingPaymentInstrument = false;
  changingPercentage = 0;
  
  constructor(private dialogService: DialogService,
    private organizationService: OrganizationResource,
    private subscriptionPlanService: SubscriptionPlanResource,
    private accountService: AccountResource,
    private subscriptionInvoiceResource: SubscriptionInvoiceResource,
    private subscriptionPlanResource: SubscriptionPlanResource) { }

  async ngOnInit() {
    const org = await this.loadCurrentOrganization();
    this.loadSubscriptionPlan(org.subscriptionPlan);
    this.loadNumberOfWorkers();
    this.loadInvoices();

  }

  async loadCurrentOrganization(): Promise<Organization> {
    this.organization = await this.organizationService.findById('current');
    return this.organization;
  }

  async loadSubscriptionPlan(planId: string) {
    if(planId != null) {
      this.subscriptionPlan = await this.subscriptionPlanService.findById(planId);
    }
  }

  async loadNumberOfWorkers() {
    const page = await this.accountService.findAll({size: 1});
    this.numberOfWorkers = page.totalElements;
  }

  async loadInvoices() {
    this.invoices = (await this.subscriptionInvoiceResource.findAll()).content;
  }

  getPrice() {
    if(this.subscriptionPlan) {
      return SubscriptionPlanCalculator.calculatePrice(this.subscriptionPlan, this.numberOfWorkers);
    } else {
      return 0;
    }
  }

  getCurrency() {
    return this.subscriptionPlan?.currencyCode.toUpperCase();
  }
  
  async enableSubscription() {
    if(this.organization?.subscriptionCardNumber == null) {
      Stallion.alert($localize`Please attach a credit card first.`)
      return;
    }

    if(await Stallion.confirm($localize`Do you want to activate you subscription?`)) {
      this.togglingSubscription = true;
      await this.subscriptionPlanResource.reactivateSubscription(this.organization.id);
      this.togglingSubscription = false;
      this.loadCurrentOrganization();
    }


  }

  async cancelSubscription() {
    if(await Stallion.confirm($localize`Do you want to cancel your subscription? It will expire when your current subscription period ends.`, 'danger', $localize`No, I want to keep my subscription`, $localize`Yes, cancel subscription`)) {
   
      this.togglingSubscription = true;
      this.loading = true;
      await this.subscriptionPlanResource.cancelSubscription(this.organization!.id);
      this.togglingSubscription = false;
      this.loading = false;
      this.loadCurrentOrganization();
    }
  }

  doDownloadInvoice(invoice: any) {
    window.location.href = invoice.invoiceUrl;
  }

  async onNewPaymentToken(token: any) {
    this.visible = false;
      
    let details: PaymentDetails = {
      cardNumber: `**** **** **** ${token.card.last4}`,
      paymentSystem: token.card.brand,
      token: token.id
    }
    this.loading = true;
    this.changingPaymentInstrument = true;
    this.changingPercentage = 0;

    let percentageTimout = setInterval(() => {
     this.changingPercentage += 60;
     
     if(this.changingPercentage >= 100) {
       this.changingPercentage = 100;
       clearTimeout(percentageTimout);
     } 
    }, 1000);

    await this.subscriptionPlanResource.changePaymentInstrument(this.organization!.id, details);
    this.changingPaymentInstrument = false;
    this.changingPercentage = 100;
    this.loading = false;
    this.loadCurrentOrganization();
  }

  addCard() {
    const data: Data = {
      organization: this.organization!
    }
    this.dialogService.open(StripeComponent, $localize`Add Credit Card`, {data}).afterClosed().subscribe((result: Result) => {
      if(result) this.onNewPaymentToken(result.token);
    });
  }

  async removePaymentToken() {
    this.loading = true;
    await this.subscriptionPlanResource.changePaymentInstrument(this.organization!.id, { token: null, cardNumber: null, paymentSystem: null });
    this.loading = false;
    this.loadCurrentOrganization();
  }

}
